import { AppBar, Toolbar } from '@mui/material';
import { SelectCondominium, Spacer } from '..';

import logo from '../../assets/logo.png';
import { useCondominiumContext } from '../../contexts/CondominiumContext';
import useStyles from './styles';

interface HeaderProps {
  title?: string;
}

export default function Header({ title }: HeaderProps) {
  const classes = useStyles();
  const { condominium } = useCondominiumContext();

  return (
    <>
      <AppBar className={classes.appBar} elevation={0}>
        <div className={classes.yellowBar} />
        <Toolbar className={classes.toolbar} >
          <div className={classes.logo}>
            <img src={logo} alt="Apepe Manager" style={{ maxWidth: '90px' }} />
          </div>
          <div className={classes.title}><span>{title}</span></div>
          <Spacer />
          { condominium && <SelectCondominium /> }
        </Toolbar>
      </AppBar>
    </>
  );
}
